import React from "react";
import FusionTech from "../assets/Clients Logo/Fusion Tech.png"
import ORL from "../assets/Clients Logo/ORL.png"
import Kiwi from "../assets/Clients Logo/Kiwi New Energy.png"
import Formosa from "../assets/Clients Logo/Formosa.png"
import futurelocus from "../assets/Clients Logo/futurelocus.png"
import SelfieSign from "../assets/Clients Logo/SelfieSign logo_HD.png"
import ThinkCloud from "../assets/Clients Logo/ThinkCloud雲想科技_橫式Logo_彩色黑字_版本1.png"
import { InfiniteCompany } from "./ui/infinite-company";
import { InfiniteCompany2 } from "./ui/infinite-company2";
import Avatar1 from '../assets/avatarReact.png'
import Avatar2 from '../assets/avatarRedux.png'
import Avatar3 from '../assets/avatarTs.png'
import Avatar4 from '../assets/avatartailwind.png'
import Avatar5 from '../assets/avatarJS.png'



const company = [
  {
    id: "2",
    text: 'graphic design',
  },
  {
    id: "3",
    text: 'FRONTEND development',
  },
  {
    id: "4",
    text: 'Web design',
  },
  {
    id: "2",
    text: 'UI/UX',




  },
  {
    id: "3",
    text: 'interaction design',
  },
  {
    id: "4",
    text: 'brand design',
  },

];

const Clients = () => {
  return (
    <div className=" flex-col   flex justify-center items-center w-12/12 ">

      <div id='About' className="w-full flex flex-col overflow-hidden">
        {[1, 2].map((_, index) => (
          <div key={index} id="scroller" className="overflow-hidden">
            {[1, 2].map((_, innerIndex) => (
              <div key={innerIndex} id={index === 0 ? "scroller-in" : "scroller-in2"} className="uppercase text-3xl sm:text-4xl md:text-5xl lg:text-7xl xl:text-[80px] leading-tight">
                {[
                  "   JavaScript", "TypeScript", "React", "Next.js", "UI/UX", "Tailwind CSS",
                  "Frontend Development", "Responsive", "React Query", "Redux",
                  "Zustand", "State Management", "Hooks", "Figma", "Component Libraries",
                  "API Integration", "Version Control", "   Vercel",
                  "   Webpack", "Babel", "Rest APIs"
                ].map((skill, idx) => {
                  const avatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar5];
                  return (
                    <div key={idx} className="inline-flex items-center gap-4 sm:gap-3 md:gap-4 px-4 sm:px-4 md:px-6">
                      <h4 className="lg:whitespace-nowrap !tracking-tight  !md:tracking-tight font-bold">{skill}</h4>
                      <img
                        src={avatars[idx % avatars.length]}
                        className="w-12 h-12 lg:pr-2.5 pr-4 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain p-1 flex-shrink-0"
                        alt="avatar"
                      />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        ))}

      </div>
      {/* <InfiniteCompany2
        items={company}
        direction="left"
        speed="slow"
        className="w-full py-0"
      />
       <InfiniteCompany2
        items={company}
        direction="right"
        speed="slow"
        className="w-full py-0"
      /> */}


    </div>
  );
};

export default Clients;
